import { render, staticRenderFns } from "./protocolDetail.vue?vue&type=template&id=bc13fc8e&scoped=true"
import script from "./protocolDetail.vue?vue&type=script&lang=js"
export * from "./protocolDetail.vue?vue&type=script&lang=js"
import style0 from "./protocolDetail.vue?vue&type=style&index=0&id=bc13fc8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc13fc8e",
  null
  
)

export default component.exports